

module.exports = __webpack_require__.stylable.create(
    "CurrenciesDropdown376104280",
    {"classes":{"root":"CurrenciesDropdown376104280__root"},"vars":{},"stVars":{"backgroundColor":"'\"fallback(color(--currencyConverter_backgroundColor), color(color-1))\"'","borderColor":"'\"color(fallback(--currencyConverter_borderColor, color-5))\"'","font":"'\"fallback(font(--currencyConverter_textFont), font({theme: 'Body-M', size: '16px'}))\"'","textColor":"'\"fallback(color(--currencyConverter_textColor), color(color-5))\"'","disabledColor":"'\"color(color-3)\"'","borderWidth":"'\"fallback(unit(--currencyConverter_borderWidth, px), 1px)\"'"},"keyframes":{}},
    "",
    10,
    "CurrenciesDropdown376104280",
    null
);
